import {Skeleton} from '@/components/ui/skeleton'

export function ProductFacetSkeleton() {
  return (
    <aside className="lg:sticky lg:top-20" aria-hidden="true">
      <div className="flex items-center justify-between">
        <Skeleton className="h-5 w-20" />
        <Skeleton className="h-4 w-16" />
      </div>
      <Skeleton className="my-site-sm h-px w-full" />
      <div className="space-y-site-sm">
        {[0, 1, 2].map((sectionIndex) => (
          <div key={sectionIndex}>
            <div className="flex items-center justify-between">
              <Skeleton className="h-5 w-28" />
              <Skeleton className="size-4" />
            </div>
            <div className="mt-3 space-y-2.5">
              {[0, 1, 2, 3].map((optionIndex) => (
                <div key={optionIndex} className="flex items-center gap-2.5">
                  <Skeleton className="size-4 shrink-0" />
                  <Skeleton className="h-4 flex-1" />
                  <Skeleton className="h-3 w-8" />
                </div>
              ))}
            </div>
            <Skeleton className="mt-site-sm h-px w-full" />
          </div>
        ))}
      </div>
    </aside>
  )
}
